export default function(){
    var Tawk_API=window.Tawk_API||{}, Tawk_LoadStart=new Date();
    var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
    s1.async=true;
    s1.src='https://embed.tawk.to/68dfd4ce0412cf195051ae6d/1j6l5ehfa';
    s1.charset='UTF-8';
    s1.setAttribute('crossorigin','*');
    s0.parentNode.insertBefore(s1,s0);
}



// WEBPACK FOOTER //
// app/pages/SupportWidget.js